// extracted by mini-css-extract-plugin
export default {"embedbody":"EmbedScriptModal_embedbody__OFeBE"};